
import { Type } from "@angular/core";

export const CUSTOM_FIELD_REGISTER: { [name: string]: Type<any> } = {

};
